export class Pagination{
	public current_page = 1;
	public from = 0;
	public to = 0;
	public total = 0;
	public last_page = 0;

	public next_disabled: boolean = true;
	public prev_disabled: boolean = true;
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/pagination.ts